import script from "./FirstTimeWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstTimeWizard.vue?vue&type=script&setup=true&lang=js"

import "./FirstTimeWizard.vue?vue&type=style&index=0&id=e81f87f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e81f87f4"]])

export default __exports__